import DOMPurify from 'dompurify';

export const sanitizeHtmlContent = (text: string) => {
  return DOMPurify.sanitize(text || '', {
    ADD_ATTR: ['target'],
    ALLOWED_TAGS: ['b', 'strong', 'ul', 'li', 'a', 'p', 'br', 'h1', 'h2', 'h3', 'h4'],
    ALLOWED_ATTR: ['href', 'target'],
  }).replace(/\n/gi, '</br>');
};
